module.exports = __webpack_public_path__ + "img/2.00d6751a.jpg";